(function () {
  "use strict";

  const gallery = document.querySelector(".gallery");
  if (!gallery) return;

  const dataEl = document.querySelector("[data-orbital-products]");
  let products = [];
  try {
    products = JSON.parse(dataEl.textContent);
  } catch (e) {
    products = [];
  }
  if (!products.length) return;

  const galleryConfig = {
    ovalWidthRatio: 0.3,
    ovalHeightRatio: 0.28,
    tiltAngle: -20,
    idleRotationSpeed: 0.035,
    scrollAcceleration: 0.0055,
    touchDragFactor: 0.25,
    maxRotationSpeed: 2.5,
    speedEasing: 0.05,
    hoverScale: 1.1,
    idleImageZoom: 1.1,
    dimmedBrightness: 0.35,
    touchDimSaturate: 0.35,
    touchDimBrightness: 0.75,
  };

  const EASE = "cubic-bezier(0.16, 1, 0.3, 1)"; /* expo.out */
  const HOVER_MS = 1000;

  const infoBox = document.querySelector(".product-info");
  const infoTitle = document.querySelector(".product-title");
  const infoPrice = document.querySelector(".product-price");
  if (infoBox) infoBox.style.transition = "opacity 0.5s ease";

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  /* intro-loader: prima il logo (stella → cerchi), poi le foto */
  const LOGO_INTRO_MS = reduceMotion ? 0 : 1800;
  const touchMode = window.matchMedia("(hover: none)").matches || window.innerWidth < 700;

  const galleryItems = [];

  let ovalRadiusX = 0;
  let ovalRadiusY = 0;
  let tiltCos = 0;
  let tiltSin = 0;

  let ringRotation = 0;
  let rotationDirection = 1;
  let rotationSpeed = galleryConfig.idleRotationSpeed;
  let logoHover = false;
  let dragging = false;

  let pointerX = -1;
  let pointerY = -1;
  let hoveredItem = null;

  products.forEach((product, index) => {
    const wrapper = document.createElement("div");
    wrapper.className = "item";

    const frame = document.createElement("div");
    frame.className = "img";

    const image = document.createElement("img");
    image.src = product.img;
    if (product.srcset) image.srcset = product.srcset;
    image.sizes = "250px";
    image.alt = product.title || "";
    image.loading = index < 6 ? "eager" : "lazy";
    image.decoding = "async";

    frame.appendChild(image);
    wrapper.appendChild(frame);
    gallery.appendChild(wrapper);

    wrapper.addEventListener("click", () => {
      if (product.url) window.location.href = product.url;
    });

    /* base state (replaces gsap.set) */
    frame.style.transform = "scale(1)";
    frame.style.opacity = "0";
    frame.style.transition = "transform " + HOVER_MS + "ms " + EASE;
    image.style.transform = "scale(" + galleryConfig.idleImageZoom + ")";
    image.style.transition = "transform " + HOVER_MS + "ms " + EASE;
    wrapper.style.filter = "saturate(1) brightness(1)";
    wrapper.style.transition = "filter " + HOVER_MS + "ms " + EASE;

    const ringAngle = (index / products.length) * Math.PI * 2;
    galleryItems.push({
      wrapper,
      frame,
      image,
      ringAngle,
      product,
      images: Array.isArray(product.images) ? product.images : [],
      imgIndex: 0,
      reveal: reduceMotion ? 1 : 0,
      blur: 0,
      revealDelay: LOGO_INTRO_MS + index * 90,
      revealDur: 1200,
    });
  });

  /* preload every ring image during the intro splash so swaps never flash the background */
  galleryItems.forEach((it) => {
    (it.images || []).forEach((src) => {
      const im = new Image();
      im.src = src;
    });
  });

  function measureGallery() {
    const mobile = window.innerWidth < 700;
    ovalRadiusX = window.innerWidth * (mobile ? 0.37 : galleryConfig.ovalWidthRatio);
    ovalRadiusY = window.innerHeight * (mobile ? 0.3 : galleryConfig.ovalHeightRatio);

    const tiltRadians = (galleryConfig.tiltAngle * Math.PI) / 180;
    tiltCos = Math.cos(tiltRadians);
    tiltSin = Math.sin(tiltRadians);
  }

  function positionItem(item, rotationRadians) {
    const angle = item.ringAngle + rotationRadians;
    const ovalX = Math.cos(angle) * ovalRadiusX;
    const ovalY = Math.sin(angle) * ovalRadiusY;

    const tiltedX = (ovalX * tiltCos - ovalY * tiltSin) * item.reveal;
    const tiltedY = (ovalX * tiltSin + ovalY * tiltCos) * item.reveal;

    item.wrapper.style.transform = "translate(" + tiltedX + "px, " + tiltedY + "px)";

    const depth = (Math.sin(angle) + 1) / 2;
    const z = item === hoveredItem ? 95 : 10 + Math.round(depth * 80);
    if (z !== item.z) {
      item.z = z;
      item.wrapper.style.zIndex = z;
    }

    /* animated blur re-rasterizes every image per frame on iOS Safari: desktop only */
    if (!touchMode) {
      const targetBlur = item === hoveredItem ? 0 : (1 - depth) * 1.5;
      item.blur += (targetBlur - item.blur) * 0.12;
      const rounded = item.blur.toFixed(2);
      if (rounded !== item.lastBlur) {
        item.lastBlur = rounded;
        item.image.style.filter = "blur(" + rounded + "px)";
      }
    }
  }

  measureGallery();
  galleryItems.forEach((item) => positionItem(item, 0));

  window.addEventListener(
    "wheel",
    (event) => {
      rotationDirection = event.deltaY > 0 ? 1 : -1;
      rotationSpeed += Math.abs(event.deltaY) * galleryConfig.scrollAcceleration;
      rotationSpeed = Math.min(rotationSpeed, galleryConfig.maxRotationSpeed);
    },
    { passive: true }
  );

  /* intro reveal driven from timestamps inside the main loop */
  let introStart = reduceMotion ? -Infinity : null;

  function easeExpoOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    return 1 - Math.pow(2, -10 * t);
  }

  let lastFrame = null;
  let introDone = reduceMotion;
  let infoRevealed = reduceMotion;

  function animateGallery(now) {
    if (introStart === null) introStart = now;

    /* time-based rotation: speed stays constant even when Safari drops frames */
    const dtScale = lastFrame === null ? 1 : Math.min((now - lastFrame) / 16.667, 3);
    lastFrame = now;

    const idleTarget = logoHover
      ? galleryConfig.idleRotationSpeed * 3
      : galleryConfig.idleRotationSpeed;
    if (!dragging) {
      rotationSpeed += (idleTarget - rotationSpeed) * galleryConfig.speedEasing * dtScale;
      ringRotation += rotationSpeed * rotationDirection * dtScale;
    }
    const rotationRadians = (ringRotation * Math.PI) / 180;

    if (!introDone) {
      introDone = true;
      galleryItems.forEach((item) => {
        if (item.revealEnded) return;
        const t = (now - introStart - item.revealDelay) / item.revealDur;
        item.reveal = easeExpoOut(t);
        item.frame.style.opacity = Math.min(1, Math.max(0, t * 1.5)).toString();
        if (t >= 1) item.revealEnded = true;
        else introDone = false;
      });
    }

    const itemUnderCursor = touchMode ? getFrontItem(rotationRadians) : getHoveredItem();
    if (itemUnderCursor !== hoveredItem) {
      applyHoverState(itemUnderCursor);
      hoveredItem = itemUnderCursor;
    } else if (introDone && !infoRevealed) {
      /* intro appena finita: mostra il testo anche se l'item frontale non è cambiato */
      applyHoverState(hoveredItem);
    }
    if (introDone) infoRevealed = true;

    galleryItems.forEach((item) => positionItem(item, rotationRadians));
    requestAnimationFrame(animateGallery);
  }

  if (reduceMotion) {
    galleryItems.forEach((item) => (item.frame.style.opacity = "1"));
  }
  requestAnimationFrame(animateGallery);

  /* touch: the finger drives the ring 1:1 while down, momentum on release.
     touchmove is NON-passive: without preventDefault, iOS Safari claims the
     downward swipe as rubber-band/pull-to-refresh. Overlays with their own
     scroll (cart drawer, mobile menu) are exempt. */
  const inOverlay = (event) =>
    event.target.closest && event.target.closest(".cart-drawer, .mobile-menu");
  let lastTouchY = null;
  let touchVelocity = 0;
  window.addEventListener(
    "touchstart",
    (event) => {
      if (inOverlay(event)) return;
      lastTouchY = event.touches[0].clientY;
      touchVelocity = 0;
      dragging = true;
    },
    { passive: true }
  );
  window.addEventListener(
    "touchmove",
    (event) => {
      if (inOverlay(event) || lastTouchY === null) return;
      if (event.cancelable) event.preventDefault();
      const y = event.touches[0].clientY;
      const delta = lastTouchY - y;
      if (delta !== 0) {
        rotationDirection = delta > 0 ? 1 : -1;
        ringRotation += delta * galleryConfig.touchDragFactor;
        touchVelocity = touchVelocity * 0.6 + delta * 0.4;
      }
      lastTouchY = y;
    },
    { passive: false }
  );
  window.addEventListener("touchend", () => {
    if (!dragging) return;
    lastTouchY = null;
    dragging = false;
    rotationSpeed = Math.min(
      Math.abs(touchVelocity) * galleryConfig.touchDragFactor,
      galleryConfig.maxRotationSpeed
    );
  });

  window.addEventListener("mousemove", (event) => {
    pointerX = event.clientX;
    pointerY = event.clientY;
  });
  window.addEventListener("mouseleave", () => {
    pointerX = -1;
    pointerY = -1;
  });

  function getFrontItem(rotationRadians) {
    let best = null;
    let bestDepth = -2;
    galleryItems.forEach((item) => {
      const depth = Math.sin(item.ringAngle + rotationRadians);
      if (depth > bestDepth) {
        bestDepth = depth;
        best = item;
      }
    });
    return best;
  }

  function getHoveredItem() {
    if (pointerX < 0) return null;
    const target = document.elementFromPoint(pointerX, pointerY);
    const hovered = target ? target.closest(".item") : null;
    return hovered ? galleryItems.find((item) => item.wrapper === hovered) || null : null;
  }

  function applyHoverState(activeItem) {
    if (activeItem && infoTitle && infoPrice) {
      infoTitle.textContent = activeItem.product.title;
      infoPrice.textContent = activeItem.product.price;
    }
    /* il testo compare solo a foto apparse (fine intro) */
    if (infoBox) infoBox.style.opacity = activeItem && introDone ? "1" : "0";

    galleryItems.forEach((item) => {
      const isActive = item === activeItem;
      const isDimmed = activeItem && !isActive;

      item.frame.style.transform = isActive ? "scale(" + galleryConfig.hoverScale + ")" : "scale(1)";
      item.image.style.transform = isActive ? "scale(1)" : "scale(" + galleryConfig.idleImageZoom + ")";
      /* su touch l'item frontale è sempre "hovered": gli altri prendono un
         dim ridotto (desaturazione parziale), non il b/n pieno del desktop */
      if (isDimmed) {
        item.wrapper.style.filter = touchMode
          ? "saturate(" + galleryConfig.touchDimSaturate + ") brightness(" + galleryConfig.touchDimBrightness + ")"
          : "saturate(0) brightness(" + galleryConfig.dimmedBrightness + ")";
      } else {
        item.wrapper.style.filter = "saturate(1) brightness(1)";
      }
    });
  }

  window.addEventListener("resize", measureGallery);

  /* logo hover: accelerate the ring a touch (the scale-up is handled in CSS) */
  const logoWrap = document.querySelector(".gallery-logo");
  if (logoWrap) {
    logoWrap.style.pointerEvents = "auto";
    logoWrap.addEventListener("mouseenter", () => {
      logoHover = true;
    });
    logoWrap.addEventListener("mouseleave", () => {
      logoHover = false;
    });
  }

  /* home: every so often a random ring item spins to its next product photo */
  if (!reduceMotion) {
    setInterval(() => {
      if (document.hidden) return;
      const pool = galleryItems.filter((it) => it.images && it.images.length > 1);
      if (!pool.length) return;
      const item = pool[Math.floor(Math.random() * pool.length)];
      item.imgIndex = (item.imgIndex + 1) % item.images.length;
      const src = item.images[item.imgIndex];
      const pre = new Image();
      pre.onload = () => {
        item.image.removeAttribute("srcset");
        item.image.src = src;
      };
      pre.src = src;
    }, 1100);
  }

  /* ---------- intro: logo rings pop in, then header/footer fade ---------- */
  const header = document.querySelector(".site-header");
  const footer = document.querySelector(".site-footer");
  const logoPaths = document.querySelectorAll(".gallery-logo svg path");

  function revealChrome() {
    [header, footer].forEach((el) => {
      if (!el) return;
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    });
  }

  /* logo rings: purple, green, yellow, red (paths order in file: red,green,purple,yellow) */
  const red = logoPaths[0];
  const green = logoPaths[1];
  const purple = logoPaths[2];
  const yellow = logoPaths[3];
  const appearOrder = [purple, green, yellow, red].filter(Boolean);
  let chromeTimer = null;

  function playLogoIntro() {
    /* reset istantaneo (niente transition) così si può rigiocare al ritorno in home */
    appearOrder.forEach((path) => {
      path.style.transition = "none";
      path.style.transitionDelay = "0s";
      path.style.transform = "scale(0)";
    });
    [header, footer].forEach((el, i) => {
      if (!el) return;
      el.style.transition = "none";
      el.style.opacity = "0";
      el.style.transform = i === 0 ? "translateY(-16px)" : "translateY(16px)";
    });
    void document.body.offsetHeight; /* flush: lo scale(0) deve atterrare prima di rianimare */

    requestAnimationFrame(() => {
      appearOrder.forEach((path, i) => {
        path.style.transition = "transform 0.9s cubic-bezier(0.34, 1.56, 0.64, 1)";
        path.style.transitionDelay = (0.3 + i * 0.45).toFixed(2) + "s";
        path.style.transform = "scale(1)";
      });
      [header, footer].forEach((el) => {
        if (el) el.style.transition = "opacity 0.8s ease, transform 0.8s ease";
      });
    });

    /* header/footer fade after the ring has revealed */
    clearTimeout(chromeTimer);
    const chromeDelay = LOGO_INTRO_MS + 600 + galleryItems.length * 90;
    chromeTimer = setTimeout(revealChrome, Math.min(chromeDelay, LOGO_INTRO_MS + 2600));
  }

  function restartIntro() {
    if (reduceMotion) return;
    introStart = null;
    introDone = false;
    infoRevealed = false;
    if (infoBox) infoBox.style.opacity = "0";
    galleryItems.forEach((item) => {
      item.reveal = 0;
      item.revealEnded = false;
      item.frame.style.opacity = "0";
    });
    playLogoIntro();
  }

  if (reduceMotion) {
    revealChrome();
  } else {
    playLogoIntro();
  }

  /* back/forward da un prodotto: la bfcache ripristina la pagina già "finita",
     l'intro deve rigirare sempre */
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) restartIntro();
  });
})();
